import React from 'react';
import Sidebar from '../menu/sidebar';
import BottomBar from '../menu/BottomBar';
import useAdminActivityTracker from '../../api/APIInterceptor';

const AdminLayout = ({ children }) => {
  useAdminActivityTracker();

  return (
    <div className="admin-layout">
      <Sidebar />
      <div className="admin-content">
        {children}
      </div>
      <BottomBar />
    </div>
  );
};

export default AdminLayout;